import ProductRepository from '@/shared/http/repositories/configuration/product'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'product/products'
const GET_PRODUCT_BY_ID = 'getProductById'
const GET_ALL_PRODUCTS = 'getAllProducts'
const GET_PRODUCTS_BY_INSURANCE_BUSINESSTYPE = 'getProductsByInsuranceBusinessType'

export const actionTypes = {
  GET_PRODUCT_BY_ID,
  GET_ALL_PRODUCTS,
  GET_PRODUCTS_BY_INSURANCE_BUSINESSTYPE
}

export const actions = {
  [GET_PRODUCT_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_PRODUCT, payload)
  },

  async [GET_ALL_PRODUCTS] ({ commit }, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      const res = await ProductRepository.GetAll()
      commit(mutation.SET_PRODUCTS, res.data)
    }
  },

  async [GET_PRODUCTS_BY_INSURANCE_BUSINESSTYPE] ({ commit }, insuranceID, businessTypeID, forceReload) {
    // if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
    // const res = await ProductRepository.GetByInsuranceAndBusinessType(insuranceID, businessTypeID)
    // commit(mutation.SET_PRODUCTS, res.data)
    // }

    console.log(insuranceID)
    console.log(businessTypeID)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/product/actions.js